import http from "@/api";

export default {
  getPlayer: async () => {
    try {
      const players = await http.get( '/player/list' )
      return players.data.data;
    }
    catch (error) {
      console.error('Error fetching players:', error);
      throw error;
    }
  }
}
